<app-navbar class="d-none d-sm-block"></app-navbar>
<nav class="navbar sticky-top navbar-light shadow-sm p-1">
    <a href="#" routerLink="/documents" class="btn btn-sm btn-primary">
        <i-feather name="chevron-left"></i-feather> Back
    </a>
</nav>

<div style="background-color: black;">
    <img src="./assets/invoice.jpg" alt="" class="img-fluid">
</div>